module.exports = __webpack_public_path__ + "img/thumb_20.c8bee0e4.jpg";